import * as React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Grid, createMuiTheme, ThemeProvider, makeStyles } from '@material-ui/core';
import overcentric from 'overcentric';

import UserProfile from 'components/sidebar/UserProfile';
import SidebarMenu from 'components/sidebar/SidebarMenu';
import * as AppPages from 'pages/app';
import { NotFound } from 'pages';
import ProtectedRoute from 'components/ProtectedRoute';

// Customize Material theme
const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#0ca3d9'
        },
        secondary: {
            main: '#fff'
        }
    }
});

const AppDashboard = ({ location, appState, onShowTutorial, onProfileUpdate }) => {
    let urlParams = new URLSearchParams(location.search);
    const isWebRecorder = urlParams.get('vm') === 'web_recorder';

    React.useEffect(() => {
        if (!isWebRecorder) {
            overcentric.setContext('product');
        }
    }, []);

    // Now guest (non-logged-in users) can see parts of the app dashboard

    // if (!appState.loggedIn) {
    //     if (location.pathname.includes('surgery') || location.pathname.includes('/v/')) {
    //         window.location = '/login?lp=' + location.pathname;
    //         return;
    //     }

    //     window.location = '/login';
    //     return;
    // }

    const {
        email,
        firstName,
        lastName,
        role,
        roleStatus,
        userId,
        // groups, registered,
        profileImg,
        title,
        hasSeenTutorial,
        id
    } = appState;

    const appUser = {
        email,
        firstName,
        lastName,
        role,
        roleStatus,
        userId,
        profileImg,
        title,
        hasSeenTutorial,
        id
    };

    const classes = useStyles();

    const isOnSurgeryBroadcastPage = location.pathname.includes('/app/surgery/broadcast/');
    const showSidebar = appState.loggedIn && !isOnSurgeryBroadcastPage;

    // Fix since Dr. Stetson cant be set to admin role because he would lose the ability to broadcast then
    const isStetson = appUser.email === 'wbstetsonmd@gmail.com';

    return (
        <ThemeProvider theme={theme}>
            <div className={classes.root} style={{
                minHeight: isOnSurgeryBroadcastPage ? '100vh' : 'calc(100vh - 7rem)'
            }}>
                <Grid container className={classes.rootContainer}>
                    {
                        (showSidebar) ?
                            <Grid item xs={12} md={1} lg={2} className={classes.sidebar}>
                                <div id="userSidebarMenu" className="UserSidebarMenu sticky-sidebar">
                                    <UserProfile user={appUser} />
                                    <SidebarMenu user={appUser} />
                                </div>
                            </Grid>
                            :
                            null
                    }

                    <Grid
                        item
                        xs={12}
                        md={showSidebar ? 11 : 12}
                        lg={showSidebar ? 10 : 12}
                        className={classes.content}
                        style={{
                            backgroundColor: !isOnSurgeryBroadcastPage ? '#f7f7f7' : 'transparent'
                        }}>
                        <div style={{ height: '100%' }}>
                            <Switch>
                                <ProtectedRoute
                                    exact
                                    path='/app'
                                    isLoggedIn={appState.loggedIn}
                                    render={(props) => <AppPages.MyDashboard user={appUser} onShowTutorial={onShowTutorial} />} />

                                <Route
                                    exact
                                    path='/app/surgeries'
                                    render={(props) => <AppPages.Surgeries user={appUser} />} />

                                <Route
                                    exact
                                    path='/app/surgery/:id'
                                    render={(props) => <AppPages.Surgery user={appUser} />} />

                                <Route
                                    exact
                                    path='/app/surgery/broadcast/:id'
                                    render={(props) => <AppPages.SurgeryBroadcast user={appUser} />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/archived-surgeries'
                                    isLoggedIn={appState.loggedIn}
                                    render={(props) => <AppPages.SurgeriesArchive user={appUser} />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/archived-surgeries/past-my'
                                    isLoggedIn={appState.loggedIn}
                                    render={(props) => <AppPages.PreviousSurgeries user={{ ...appUser, role: 'broadcaster' }} type="past-my" hideBroadcaster tableTitle="My Past Surgeries" />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/past-surgeries'
                                    isLoggedIn={appState.loggedIn}
                                    render={(props) => <AppPages.PreviousSurgeries user={appUser} />} />

                                <Route
                                    exact
                                    path='/app/discover-broadcasters'
                                    render={(props) => <AppPages.DiscoverBroadcasters user={appUser} />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/explore/:tabID?'
                                    isLoggedIn={appState.loggedIn && appUser}
                                    render={(props) => <AppPages.Explore user={appUser} />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/new-surgery'
                                    isLoggedIn={appState.loggedIn && appUser && appUser.role !== 'user' && appUser.roleStatus !== 'inactive'}
                                    render={(props) => <AppPages.NewSurgery user={appUser} />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/subscriptions'
                                    isLoggedIn={appState.loggedIn && appUser && appUser.role !== 'admin'}
                                    render={(props) => <AppPages.FollowedBroadcasters user={appUser} />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/edit-surgery/:id'
                                    isLoggedIn={appState.loggedIn && appUser && appUser.role !== 'user'}
                                    render={(props) => <AppPages.EditSurgery user={appUser} />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/groups'
                                    isLoggedIn={appState.loggedIn && appUser && appUser.role !== 'user'}
                                    render={(props) => <AppPages.Groups user={appUser} />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/g/:id'
                                    isLoggedIn={appState.loggedIn && appUser && appUser.role !== 'user'}
                                    render={(props) => <AppPages.Group user={appUser} />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/broadcasters'
                                    isLoggedIn={appState.loggedIn && appUser && appUser.role === 'admin'}
                                    render={(props) => <AppPages.Broadcasters user={appUser} create />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/invites'
                                    isLoggedIn={appState.loggedIn && appUser && (appUser.role === 'admin' || isStetson)}
                                    render={(props) => <AppPages.Invites user={appUser} create />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/admin-feedback'
                                    isLoggedIn={appState.loggedIn && appUser && appUser.role === 'admin'}
                                    render={(props) => <AppPages.AdminFeedback user={appUser} />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/viewers'
                                    isLoggedIn={appState.loggedIn && appUser && appUser.role !== 'user'}
                                    render={(props) => <AppPages.Viewers user={appUser} mode="view-public" />} />

                                <ProtectedRoute 
                                    exact 
                                    path='/app/v/:id' 
                                    isLoggedIn={appState.loggedIn && appUser && appUser.role !== 'user'}
                                    render={(props) => <AppPages.UserProfile user={appUser} role="user" mode="view-public" />} />

                                <ProtectedRoute
                                    exact
                                    path='/app/my-profile'
                                    isLoggedIn={appState.loggedIn}
                                    render={(props) => <AppPages.MyProfile user={appUser} onUpdate={onProfileUpdate} />} />

                                <Route exact path='/app/:userKind/:id/:tabID?' // eslint-disable-next-line
                                    render={(props) => <AppPages.UserProfile user={appUser} role="broadcaster" mode="view-public" />} /> {/*  */}

                                <Route component={NotFound} />
                            </Switch>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </ThemeProvider>
    );
}

export default withRouter(AppDashboard);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: 'flex'
    },
    rootContainer: {
        flex: 1
    },
    sidebar: {
        flex: 1,
        backgroundColor: '#fbfbfd',
        backgroundImage: 'linear-gradient(208deg, #fdfdfd 83%, rgba(255, 255, 255, 0) 61%)',
        display: 'flex',
        flexDirection: 'column'
    },
    content: {
        backgroundColor: '#f7f7f7',
        padding: '30px 45px',
        [
            theme
                .breakpoints
                .down('lg')
        ]: {
            padding: '30px 20px'
        }
    }
}));